// extracted by mini-css-extract-plugin
module.exports = {"loader":"IconEnquiry_loader__1cRk1","root":"IconEnquiry_root__3Ie94","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__3W9oh"};